import { render } from "./AgeSelector.vue?vue&type=template&id=4564c692"
import script from "./AgeSelector.vue?vue&type=script&lang=js"
export * from "./AgeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/AgeSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4564c692"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4564c692', __exports__)) {
    api.reload('4564c692', __exports__)
  }
  
  module.hot.accept("./AgeSelector.vue?vue&type=template&id=4564c692", () => {
    api.rerender('4564c692', render)
  })

}


export default __exports__